import * as React from 'react';
import * as ReactDom from 'react-dom';

import { useContext, useReducer, useState, useEffect } from "react";
import { MessagesContext } from "../common/context";
import { messagesReducer } from "../common/reducer";

//import { graph } from '@pnp/graph';
//import { MSGraphClient } from '@microsoft/sp-http';
//import { WebPartContext } from "@microsoft/sp-webpart-base";

import { useErrorBoundary } from "use-error-boundary";
import log from 'loglevel';

import { escape } from '@microsoft/sp-lodash-subset';
import * as Fabric from 'office-ui-fabric-react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { CommandBar, ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';

import  { Team } from './Team';
import  * as uuidv4 from "uuid/v4";

import { getAuthenticatedClient } from "../../auth/authClient";
var graph = require('@microsoft/microsoft-graph-client');

export  function TeamsContainer({ accessToken }) {

  const { state , dispatch } = useContext(MessagesContext);  
  const [teams, setTeams] = useState(null);
  const [reloadTeams, setReloadTeams] = useState(true);  
  const { ErrorBoundary, didCatch, error, errorInfo } = useErrorBoundary();
               
  log.info(`function TeamsContainer`);

   React.useEffect(() => {  
    log.info(` useEffect  @ TeamsContainer`);
      if (reloadTeams) {   
            getTeams(accessToken);
            setReloadTeams(false)                   
      } 
  }, [reloadTeams]);

  const handleReloadTeams = ()=>{
    log.info(` handleReloadTeams  @ TeamsContainer`)
    setReloadTeams(true);
  };

 
  const getTeams = async ( accessToken ) =>{
    log.info(`getTeams @ TeamsContainer}`);
    log.debug(`@getTeams ACCESSTOKEN: ${accessToken}`);
    
    //https://graph.microsoft.com/v1.0/me/joinedTeams
    const teamsUrl = `/me/joinedTeams`;
    
    const client = getAuthenticatedClient(accessToken);
    //console.log(`client at getAuthenticatedClient : `);
    const res = await client.api(teamsUrl)
          .headers({
            "Content-Type" : "application/json;charset=UTF-8"
          })
          .version('beta')
          .get().then((response) => {
            
                const  selectedTeams =   response.value.map(team => {
                  
                  const _team = 
                    {
                        id :  team.id,
                        webUrl : team.webUrl,
                        displayName : team.displayName
                    };
                    return _team;
                });                
                setTeams(selectedTeams); 
          }
        )  
  };

  const _items = [
    {
      key: 'refresh',
      text: 'Refresh',
      iconProps: { iconName: 'Share' },
      onClick: () => {handleReloadTeams()}
    },
    {
      key: 'note',
      text: ' Dynamic Explorer of Teams, Channels, Messages and Replies:',
      disabled: true
    }
  ];
      
  const renderCommandBar=()=>{
    log.info(`renderCommandBar @ TeamsContainer}`);
    return (
            <CommandBar
                    items={_items}
                  />
            );  
  };
  
  const lineStyle = () => {
    const _style =
       {
            height: "1px",
            backgroundColor: "white",
        };
    return _style;
  };

  const notFoundStyle = () => {
    const _style =
       {
            color: 'grey',
            marginLeft: '100px',

        };
    return _style;
  };

  const MyErrorComponent = ({error})=>{
    log.error(`error @ TeamsContainer: ${error.message}  `);
    return (
    <div key={uuidv4()}>error</div>
    )
  }

  const renderTeams = ( accessToken )=>{

    log.info(`renderTeams @ TeamsContainer}`);

    // if (accessToken === undefined || accessToken =='') {
  //   return (
  //     <>  
  //     <div style={lineStyle()} />     
  //     <div>
  //         Please refresh to load Teams list 
  //     </div>
  //     </> 
  //   )
  // }

  if (teams == null || teams == undefined){
    return (
      <>  
      <div style={lineStyle()} /> 
      <Spinner size={SpinnerSize.large} />
      </> 
    )
    } else if ( teams.length < 1)
    {
      return (
      <>  
      <div style={lineStyle()} /> 
      <div style={notFoundStyle()}> The logged in user account is not a member of any Team.</div>
      </> 
      )
    }    

  const  _teamsList = teams.map(team => {      
              return(
                <ErrorBoundary  key={uuidv4()}
                render={() => 

                    <Team
                      key={uuidv4()}
                      teamID = {team.id}
                      team = {team}
                      accessToken = { accessToken }
                    />
                }
                renderError={({ error, errorInfo }) => <MyErrorComponent error={error} />}                             
                >
                </ErrorBoundary>              
                        
              ) ;             
            }
          )      
    return (
      <>  
          <div style={lineStyle()} />     
          {_teamsList}
      </> 
    )
  };

  return (
  <>
        {renderCommandBar()}
        {renderTeams( accessToken )}
  </>
  );
}


/**
  // const getTeams = async ( context ) =>{
  //  // console.log(`@getTeams `);
  //   //https://graph.microsoft.com/v1.0/me/joinedTeams
  //   const teamsUrl = `/me/joinedTeams`;
    
  //   //per pnp graph
  //   // graph.me.joinedTeams.get().then(teams => { setTeams(teams); });

  //   //per msGraphClient
  //   context.msGraphClientFactory
  //   .getClient()
  //   .then((client: MSGraphClient)=> {
  //           client
  //           .api(teamsUrl)
  //           .headers({
  //             "Content-Type" : "application/json;charset=UTF-8",
  //              "mode": "cors",
  //             "Access-Control-Allow-Origin" : '' 
  //           })
  //           .version('beta')
  //           .get().then((response) => {

  //               const  selectedTeams =   response.value.map(team => {
  //                 const _team = 
  //                   {
  //                       id :  team.id,
  //                       webUrl : team.webUrl,
  //                       displayName : team.displayName
  //                   };
  //                   return _team;
  //               });                
  //               setTeams(selectedTeams); 
  //               }
  //           );
  //     }
  //   );
  // };

 * 
 * 
 *      <ul>
        {channelsList.map(channel => {
          return (
              <li key={create_UUID()}>
                <a  key={create_UUID()} href={channel.webUrl}>{channel.displayName}</a>
              </li>
          );
        })}
      </ul>
 
 * 
 * 
 */
/*
 <Channel
                key={create_UUID()}
                teamId = {teamID}
                channelId = {channel.id}
                channelDisplayName = {channel.displayName}
                context = {context}
              ></Channel>

*/ 
